'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorHandlerMixin = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.globalVueErrorHandler = globalVueErrorHandler;

var _environment = require('../library/environment');

var _errorHandling = require('../library/error-handling');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Array of all known error handlers.
 * All of the handlers will be called, if an error occurs.
 * @type {Function[]}
 */
var errorHandlers = [

/**
 * Default error handler: prints information about the error on the console.
 * @param err
 * @param vm
 * @param info
 */
function (err, vm, info) {
    console.error('Vue error', err);
    console.error('Vue vm', vm);
    console.error('Vue additional information', info);
},

/**
 * Destroys the component on error, if we are currently in a deveolpment scenario.
 * @param err
 * @param vm
 * @param info
 */
function (err, vm, info) {
    console.error({ err: err, vm: vm, info: info });

    if (!(0, _environment.isInProductionMode)() && vm && vm.$el) {
        vm.$el.innerHTML = (0, _errorHandling.renderErrorMessage)(err, 'Error rendering component ' + (vm.$options._componentTag || ''));
        vm.$destroy();
    }
}];

/**
 * The mixin itself.
 * @type {{methods: {$onError: (function(*=))}}}
 */
var errorHandlerMixin = exports.errorHandlerMixin = {
    methods: {
        $onError: function $onError(handler) {
            errorHandlers.push(handler);
        }
    }
};

/**
 * The global error handler that  goes with the mixin.
 * @param err
 * @param vm
 * @param info
 */
function globalVueErrorHandler(err, vm, info) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(errorHandlers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var handler = _step.value;

            try {
                handler(err, vm, info);
            } catch (e) {
                console.error(e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}